import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/nde/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_nde"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo mb-4">
              <StaticImage
                src="../../../images/case-studies/nde/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={347}
                height={100}
              />
            </div>
            <p>
              NDE Offshore is a Swedish offshore company founded in 2005,
              operating in Sweden, Europe, and the Middle East. NDE Offshore
              offers services like inspections both above and below water,
              installation and retrofit works, periodical maintenance,
              construction support, and survey. TekRevol partnered with NDE
              Offshore for maintenance services of their web-based portals.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
